'use strict';

class BotsInfoController {
  constructor($log,
              $scope,
              $q,
              $filter,
              $state,
              $stateParams,
              utils,
              config,
              BotsService,
              LocationsService,
              DevicesService,
              ToastsService,
              I18nService) {

    // #region Define fields

    const $t = $filter('translate');
    const $date = $filter('date');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_BOT_LOCAL_STORAGE_KEY = 'Selected-Bot';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY = 'Selected-Org';
    const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Selected-Device';
    const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';

    $scope.loading = false;
    $scope.botsInfoPage = {};
    let $botsInfoPage = $scope.botsInfoPage;
    $botsInfoPage.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY); // Current org
    $botsInfoPage.botInstanceInfo = utils.getStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY); // Current bot
    const botStatuses = config.getConfigByKey('botInstanceStatuses');
    const botCommunications = config.getConfigByKey('botCommunications');
    const botCategories = config.getConfigByKey('botCategories');
    const botCommunicationTypes = config.getConfigByKey('botCommunicationTypes');
    const botAccessResources = config.getConfigByKey('botAccessResources');

    $scope.dateFormat = $t('datetime.mdyHMS12');
    $scope.sortReverse = true;

    // Set defaults
    let botLocationId = null;
    let botOrganizationId = ($state.params && $state.params.organizationId)
      ? $state.params.organizationId
      : $botsInfoPage.orgInfo.id;

    $scope.selection = $state.params && $state.params.from; // Where we came from to this page

    // Navigation Tabs
    $scope.tabs = [
      {
        id: 'details',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      }, {
        id: 'bundle',
        name: $t('bots.bundle'),
        icon: 'iotr fa-bot'
      },
      {
        id: 'access',
        name: $t('bots.access'),
        icon: 'far fa-unlock-alt'
      },
      {
        id: 'relations',
        name: $t('bots.relations'),
        icon: 'far fa-link'
      }
    ];

    // #endregion

    angular.extend($scope, {
      back: back,
      getStatus: getStatus,
      purchaseBot: purchaseBot,
      toggleStatus: toggleStatus,
      deleteBot: deleteBot,
      canToggleBotStatus: canToggleBotStatus,
      getBotDevelopmentDescription: getBotDevelopmentDescription,

      // Access
      viewDevice: viewDevice,

      // Relations
      generateAddress: generateAddress,
      viewRelation: viewRelation
    });

    initPage();

    // Please, no code execution below this line - only function definitions
    // ---------------------------------------------------------------------

    // #region Methods -------------------------------------

    function initPage() {
      $scope.loading = true;

      if ($scope.selection === 'location') {
        botLocationId = $botsInfoPage.botInstanceInfo.locationId;
        botOrganizationId = null;
        $botsInfoPage.relatedItem = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
      } else if ($scope.selection === 'organization' || $state.params.organizationId) {
        $scope.selection = 'organization';
        if ($state.params.organizationId) {
          const orgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);
          $botsInfoPage.relatedItem = orgs.find(o => o.id.toString() === $state.params.organizationId.toString());
        } else {
          $botsInfoPage.relatedItem = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
        }
      } else if ($scope.selection === 'notification') {
        botLocationId = $botsInfoPage.botInstanceInfo.locationId;
        getLocationInfo();
      }

      if (!$botsInfoPage.relatedItem) {
        $botsInfoPage.relatedItem = utils.getStorageItem(SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY);
      }

      processCommunications($botsInfoPage.botInstanceInfo.communications);
      processCategories($botsInfoPage.botInstanceInfo.bot.category);
      processAccess($botsInfoPage.botInstanceInfo.access);
      $scope.loading = false;
    }

    function back() {
      let targetRoute = 'main.bots.list';
      let params = {};
      switch ($scope.selection) {
        case 'location':
          targetRoute = 'main.locations.edit';
          params.tab = 'bots';
          break;
        case 'notification':
          targetRoute = 'main.notifications.info';
          params.tab = 'relations';
          break;
        case 'organization':
          targetRoute = 'main.organizations.edit';
          params.tab = 'bots';
          break;
        default:
          if ($state.params.locationId) {
            params.from = 'location';
            params.locationId = $state.params.locationId;
          } else if ($state.params.organizationId) {
            params.organizationId = botOrganizationId;
          } else {
            params.from = 'organization';
            params.organizationId = botOrganizationId;
          }
          break;
      }

      $state.go(targetRoute, params);
    }

    function getStatus(status) {
      const result = botStatuses.find(el => el.id === status);
      return result ? $t(result.name) : $t('bots.botStatuses.undefined');
    }

    // #endregion

    // #region Bots Functions ------------------------------

    /**
     * Request specified Bot Instance details
     */
    function getBotInstance() {
      $scope.loading = true;
      return BotsService.getBotInstance($botsInfoPage.botInstanceInfo.appInstanceId, botOrganizationId, botLocationId)
        .then(data => {
          $scope.loading = false;
          if (data.bots && data.bots.length > 0) {
            let bot = data.bots[0];
            const newStatus = bot.status;

            // TODO: Fix strange issue with SVG color
            let svgElement = $('#instance-status').find('.icon');
            svgElement.removeClass(getStatus($botsInfoPage.botInstanceInfo.status).color);
            svgElement.addClass(getStatus(newStatus).color);

            $scope.$applyAsync(() => {
              $botsInfoPage.botInstanceInfo = bot;
              utils.setStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY, bot);
            });
          }
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    /**
     * Bot communications list
     */
    function processCommunications(data) {
      $botsInfoPage.comms = [];
      if (!data || !data.length) {
        return;
      }

      data.forEach((value, index) => {
        let category = botCommunications.find(el => {
          return el.supported && el.id === value.category;
        });

        if (category) {
          let result = {
            id: value.id,
            name: category.name,
            desc: category.desc,
            icon: category.icon,
            comms: []
          };

          // Set the communications array
          botCommunicationTypes.forEach(type => {
            if (value[type.id]) {
              result.comms.push(type);
            }
          });

          $botsInfoPage.comms.push(result);
        }
      });
    }

    /**
     * Bot categories (tags)
     */
    function processCategories(data) {
      $botsInfoPage.categories = (data || '')
        .split(',')
        .map(categoryId => botCategories.find(el => el.id === categoryId))
        .filter(category => !!category && !!category.name)
        .map(category => $t(category.name))
        .join(', ');
    }

    function purchaseBot() {
      if ($scope.selection !== 'location' && $scope.selection !== 'organization') {
        return;
      }

      if ($scope.selection === 'location') {
        return BotsService.purchaseLocationBot($botsInfoPage.relatedItem.id, $botsInfoPage.botInstanceInfo.bot.bundle)
          .then(data => {
            ToastsService.success($t('bots.successPurchase'), $t('bots.successPurchaseDesc'));
            $state.go('main.locations.edit', {
              tab: 'bots'
            });
          }, err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
      }

      return BotsService.purchaseOrganizationBot($botsInfoPage.relatedItem.id, $botsInfoPage.botInstanceInfo.bot.bundle)
        .then(data => {
          ToastsService.success($t('bots.successPurchase'), $t('bots.successPurchaseDesc'));
          $state.go('main.organizations.edit', {
            tab: 'bots'
          });
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function toggleStatus() {
      if (canToggleBotStatus()) {
        return;
      }
      const status = $botsInfoPage.botInstanceInfo.status === 1 ? 2 : 1;
      return BotsService.setBotStatus($botsInfoPage.botInstanceInfo.appInstanceId, status)
        .then(() => {
          ToastsService.success();
          return getBotInstance();
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function canToggleBotStatus() {
      const botInstance = $botsInfoPage.botInstanceInfo;
      const status = botInstance.status;
      if (status !== 1 && !!botInstance.endDateMs && botInstance.endDateMs <= new Date().getTime()) {
        // The user should not be able to activate the bot instance if the endDate has already passed.
        return false;
      }
      return true;
    }

    function getBotDevelopmentDescription() {
      const botInstance = $botsInfoPage.botInstanceInfo;
      const dev = !!botInstance?.development;
      const devStr = dev ? $t('bots.developmentStates.1') : $t('bots.developmentStates.0');

      if (!!botInstance.endDateMs) {
        const isPassed = botInstance.endDateMs <= new Date().getTime();
        const dateStr = $date(botInstance.endDateMs, $scope.dateFormat);
        const endDateDesc = $t(isPassed ? 'bots.endDatePassed' : 'bots.endDateFuture', { date: dateStr });
        return `${devStr} / ${endDateDesc}`;
      }
      return devStr;
    }

    function deleteBot() {
      $scope.deleteMsg = $t('bots.delete.desc', {
        bot: $botsInfoPage.botInstanceInfo.bot.name || $botsInfoPage.botInstanceInfo.bot.bundle,
        target: $botsInfoPage.relatedItem.name,
        type: $scope.selection === 'location'
          ? ($t('locations.list.locationId') + botLocationId)
          : ($t('orgs.list.organizationId') + botOrganizationId)
      });
      $('#remove-bot-dialog').modal({
        closable: true,
        detachable: true,
        onApprove: function() {
          return BotsService.deleteBotInstance($botsInfoPage.botInstanceInfo.appInstanceId)
            .then(data => {
              $('#remove-bot-dialog').modal('hide');
              return back();
            }, err => {
              $('#remove-bot-dialog').modal('hide');
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }).modal('show');
    }

    // #endregion

    // #region Access Tab ---------------------------------

    function processAccess(data) {
      $botsInfoPage.accessTypes = [];
      $botsInfoPage.accessDeviceTypes = [];
      $botsInfoPage.accessRelations = [];
      if (!data || !data.length) {
        return;
      }

      $scope.accessLoading = true;
      DevicesService.getOrganizationDeviceTypes($botsInfoPage.orgInfo.id)
        .then(deviceData => {
          let deviceTypes = deviceData.deviceTypes || [];
          data.forEach((value, index) => {

            // Add access tags
            value.tags = [];
            value.read && value.tags.push({
              color: 'blue',
              icon: 'far fa-eye',
              name: $t('bots.accessData.read')
            });
            value.control && value.tags.push({
              color: 'red',
              icon: 'far fa-cog',
              name: $t('bots.accessData.control')
            });

            value.reason = value.reason || $t('form.desc-empty');
            if (value.deviceType) {
              let deviceType = deviceTypes.find(el => el.id === value.deviceType);
              if (!deviceType) {
                return;
              }
              value.deviceTypeName = deviceType.name;
              value.deviceTypeIcon = utils.getDeviceTypeIconName(deviceType);
            }

            // Filter out device access
            if (value && value.deviceId) {
              $botsInfoPage.accessRelations.push(value);
              return;
            }

            let category = botAccessResources.find(el => el.id === value.category);
            value.categoryName = $t(category.name);
            value.categoryIcon = category.icon;
            if (category.iconCollection) {
              value.categoryIconCollection = category.iconCollection;
            }

            // Add item to specific list
            if (value && value.deviceType) {
              $botsInfoPage.accessDeviceTypes.push(value);
            } else {
              $botsInfoPage.accessTypes.push(value);
            }

          });

          // Enrich device access relations
          if ($scope.selection === 'location' && $botsInfoPage.accessRelations.length > 0) {
            DevicesService.getLocationDevices($botsInfoPage.relatedItem.id)
              .then(data => {
                $botsInfoPage.accessRelations.forEach((relation, index) => {
                  let locationDevice = data.devices.find(el => el.id === relation.deviceId);
                  if (!locationDevice) {
                    $botsInfoPage.accessRelations.splice(index, 1);
                    return;
                  }
                  relation.deviceName = locationDevice.desc;
                });
                $botsInfoPage.locationDevices = data.devices || [];
              });
          }

          $scope.accessLoading = false;
        }, err => {
          $scope.accessLoading = false;
        });
    }

    function viewDevice(device) {
      utils.setStorageItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY, device);
      $state.go('main.devices.edit', { locationId: $botsInfoPage.relatedItem.id, deviceId: device.deviceId });
    }

    // #endregion

    // #region Relations Tab ------------------------------

    function generateAddress(data) {
      let address = utils.generateAddress(data);
      if (!address) {
        return $t('common.unknown-address');
      }
      return address;
    }

    /**
     * Get Bot Instance Location
     */
    function getLocationInfo() {
      $scope.locationLoading = true;
      return LocationsService.getLocationInfo($botsInfoPage.orgInfo.id, botLocationId)
        .then(data => {
          $scope.locationLoading = false;
          if (!data.locations || data.locations.length === 0) {
            console.log('Location not found!');
            return;
          }
          $botsInfoPage.relatedItem = data.locations.find(l => l.id === botLocationId);
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function viewRelation() {
      let targetRoute = botLocationId ? 'main.locations.edit' : 'main.organizations.edit';
      let params = {};

      if ($scope.selection === 'notification') {
        utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, $botsInfoPage.relatedItem);
      } else if ($scope.selection === 'organization') {
        utils.setStorageItem(SELECTED_ORGANIZATION_LOCAL_STORAGE_KEY, $botsInfoPage.relatedItem);
      } else {
        params.locationId = botLocationId;
      }

      $state.go(targetRoute, params);
    }

    // #endregion

  }
}

export default angular
  .module('main.botsInfo.controller', [])
  .controller('BotsInfoController', BotsInfoController)
  .name;
